export default __webpack_public_path__ + "static/media/Tailwind.f57e47e8.SVG";